import Layout from "../../Internal/Layout.vue";
import ResalesPage from "./Resales.vue";
import ResalesAdd from "./ResalesAdd/ResalesAdd.vue";
/*import ResalesRegistration from "./ResalesAdd/ResalesRegistration.vue";*/
import ResaleProfile from "./ResaleProfile/ResaleProfile.vue";

const ResalesRoutes = {
  component: Layout,
  children: [
    {
      path: "/resales",
      name: "Resales",
      component: ResalesPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
    },
    {
      path: "/add-resales",
      name: "ResalesAdd",
      component: ResalesAdd,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
      props: { resales: true },
    },
    /*{
      path: "/revendedor-cadastro",
      name: "ResalesRegistration",
      component: ResalesRegistration,
      meta: {
      },
      props: { resales: true },
    },*/
    {
      path: "/profile-resales",
      name: "ResaleProfile",
      component: ResaleProfile,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
      props: { resales: true },
    },
  ],
};

export default ResalesRoutes;
